import {
  CompletedListMedicationsAnswer,
  CompletedListPastMedicationsAnswer,
  CompletedScreeningAnswer,
  EmergencyContactsData,
  ListMedicationQuestionData,
  ListPastMedicationQuestionData,
  SCREENING_QUESTION_TYPES,
  ScreeningQuestionAnswer,
  ScreeningQuestionData,
} from "~/common/utils/consultations/screening";
import {
  AgeQuestionData,
  AudioQuestionData,
  CeroToFiveQuestionData,
  CompletedAudioAnswer,
  CompletedCeroToFiveAnswer,
  CompletedMultiCheckAnswer,
  CompletedRadioAnswer,
  CompletedTextAnswer,
  MultiCheckQuestionData,
  RadioQuestionData,
  TextQuestionData,
} from "~/common/utils/consultations/shared";
import {
  DateForm,
  EmergencyContactsForm,
  ListMedicationsForm,
  MultiCheckForm,
  RadioForm,
  ScreeningAudioForm,
  TextForm,
} from "~/patients/components/consultations";
import { EmergencyContactSchemaType } from "~/patients/utils";
import { ScreeningDateType } from "~/patients/utils/consultations/screenings";
import { CeroToFiveForm } from "../../shared/forms/CeroToFiveForm";
import { ListPastPyschMedicationsForm } from "../forms/ListPastPyschMedicationsForm";

interface QuestionRendererProps {
  handleGoBack: () => void;
  question: ScreeningQuestionData;
  isOptional: boolean;
  onSubmit: (answer: ScreeningQuestionAnswer) => void;
  isSubmitting?: boolean;
  answer?: CompletedScreeningAnswer;
  disableBack?: boolean;
}
export const ScreeningQuestionRenderer = ({
  question,
  answer,
  isOptional,
  handleGoBack,
  onSubmit,
  isSubmitting = false,
  disableBack = false,
}: QuestionRendererProps) => {
  const formContent = {
    [SCREENING_QUESTION_TYPES.radio]: (
      <RadioForm
        question={question as RadioQuestionData}
        handleGoBack={handleGoBack}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        disableBack={disableBack}
        completedAnswer={answer as CompletedRadioAnswer}
      />
    ),
    [SCREENING_QUESTION_TYPES.cero_to_five]: (
      <CeroToFiveForm
        question={question as CeroToFiveQuestionData}
        handleGoBack={handleGoBack}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        disableBack={disableBack}
        completedAnswer={answer as CompletedCeroToFiveAnswer}
      />
    ),
    [SCREENING_QUESTION_TYPES.multi_check]: (
      <MultiCheckForm
        question={question as MultiCheckQuestionData}
        handleGoBack={handleGoBack}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        disableBack={disableBack}
        completedAnswer={answer as CompletedMultiCheckAnswer}
      />
    ),
    [SCREENING_QUESTION_TYPES.text]: (
      <TextForm
        question={question as TextQuestionData}
        handleGoBack={handleGoBack}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        disableBack={disableBack}
        completedAnswer={answer as CompletedTextAnswer}
        isOptional={isOptional}
      />
    ),
    [SCREENING_QUESTION_TYPES.list_medications]: (
      <ListMedicationsForm
        question={question as ListMedicationQuestionData}
        handleGoBack={handleGoBack}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        disableBack={disableBack}
        completedAnswers={answer as CompletedListMedicationsAnswer}
      />
    ),
    [SCREENING_QUESTION_TYPES.multi_medication_name]: (
      <ListPastPyschMedicationsForm
        question={question as ListPastMedicationQuestionData}
        handleGoBack={handleGoBack}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        disableBack={disableBack}
        completedAnswers={answer as CompletedListPastMedicationsAnswer}
      />
    ),
    [SCREENING_QUESTION_TYPES.audio]: (
      <ScreeningAudioForm
        question={question as AudioQuestionData}
        handleGoBack={handleGoBack}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        completedAnswer={answer as CompletedAudioAnswer}
        disableBack={disableBack}
        isOptional={isOptional}
      />
    ),
    [SCREENING_QUESTION_TYPES.age]: (
      <DateForm
        question={question as AgeQuestionData}
        handleGoBack={handleGoBack}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        completedAnswer={answer as ScreeningDateType}
        disableBack={disableBack}
      />
    ),
    [SCREENING_QUESTION_TYPES.emergency_contact]: (
      <EmergencyContactsForm
        question={question as EmergencyContactsData}
        handleGoBack={handleGoBack}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        completedAnswers={answer as EmergencyContactSchemaType}
        disableBack={disableBack}
      />
    ),
  };

  return formContent[question.type];
};
